import { defineMessages } from 'react-intl';

const messages = defineMessages({
  orderNumber: {
    description: 'Order number column header',
    defaultMessage: 'Order #',
    id: '0B6Z+Q',
  },
  unlinkedItemLabel: {
    description: 'Placeholder order number for an item on a shipment that is not associated with a specific order',
    defaultMessage: '(None)',
    id: 'LTD7li',
  },
  itemName: {
    description: 'Label for column representing the item name',
    defaultMessage: 'Name',
    id: 'IAUOrA',
  },
  itemNameValidationError: {
    description: 'Error text explaining that the user must submit a name value in the input field',
    defaultMessage: 'Name is a required field',
    id: 'dDuV7E',
  },
  itemQuantity: {
    description: 'Label for column representing the item quantity',
    defaultMessage: 'Quantity',
    id: '/uxkhC',
  },
  itemSku: {
    description: 'Header for SKU Column on items table',
    defaultMessage: 'SKU',
    id: '5Ez9V5',
  },
  itemUnitPrice: {
    description: 'Column header for item unit price',
    defaultMessage: 'Price',
    id: 'kQQLjG',
  },
  itemNameInputPlaceholder: {
    description: 'Name input placeholder',
    defaultMessage: 'Product Name',
    id: 'f6osps',
  },
});

export default messages;
